import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import Router from './Router';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Loader from './components/Loader';

const root = ReactDOM.createRoot(document.getElementById('root'));

const App = () => {
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => setLoading(false), 2000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<React.StrictMode>
			{loading ? (
				<Loader />
			) : (
				<>
					<Navbar />
					<Router />
					<Footer />
				</>
			)}
		</React.StrictMode>
	);
};

root.render(<App />);
